import type { IThemeDOM } from "../interfaces/IThemeDOM";
import type { Theme, Mode } from "../types/theme.types";
import { themeSchema, modeSchema } from "../schemas/theme.schema";

const isBrowser = typeof globalThis.window !== "undefined";

export class BrowserThemeDOM implements IThemeDOM {
	setTheme(theme: Theme): void {
		if (!isBrowser) return;

		const validated = themeSchema.parse(theme);
		document.documentElement.dataset.theme = validated;
	}

	setMode(mode: Mode): void {
		if (!isBrowser) return;

		const validated = modeSchema.parse(mode);
		document.documentElement.dataset.mode = validated;
		this.announceChange(validated);
	}

	getSystemPreference(): Mode {
		if (!isBrowser) return "light";

		const mediaQuery = globalThis.matchMedia("(prefers-color-scheme: dark)");
		return mediaQuery.matches ? "dark" : "light";
	}

	watchSystemPreference(callback: (mode: Mode) => void): () => void {
		if (!isBrowser) return () => {};

		const mediaQuery = globalThis.matchMedia("(prefers-color-scheme: dark)");

		const handler = (event: MediaQueryListEvent) => {
			callback(event.matches ? "dark" : "light");
		};

		mediaQuery.addEventListener("change", handler);

		return () => {
			mediaQuery.removeEventListener("change", handler);
		};
	}

	announceChange(mode: Mode): void {
		if (!isBrowser) return;

		const message =
			mode === "dark" ? "Modo escuro ativado" : "Modo claro ativado";

		const announcement = document.createElement("div");
		announcement.setAttribute("role", "status");
		announcement.setAttribute("aria-live", "polite");
		announcement.style.position = "absolute";
		announcement.style.left = "-10000px";
		announcement.style.width = "1px";
		announcement.style.height = "1px";
		announcement.style.overflow = "hidden";
		announcement.textContent = message;

		document.body.appendChild(announcement);
		setTimeout(() => announcement.remove(), 1000);
	}
}
